// Selector de capa base del mapa: Mapa (CARTO) o Sin fondo · Satélite 2019 · Satélite 2026.
// Comparar 2019 vs 2026 sobre toda la ciudad es lo que hace «ver» el cambio.

import { CARTO_KEY, type BaseLayer } from './useTerritoryMap';

// Sin llave de CARTO no hay teselas: la opción se llama «Sin fondo» (solo datos).
const OPCIONES: { key: BaseLayer; label: string }[] = [
  { key: 'mapa', label: CARTO_KEY ? 'Mapa' : 'Sin fondo' },
  { key: '2019', label: 'Satélite 2019' },
  { key: '2026', label: 'Satélite 2026' },
];

export function BaseSwitch({ value, onChange }: { value: BaseLayer; onChange: (v: BaseLayer) => void }) {
  return (
    <div role="radiogroup" aria-label="Capa base del mapa"
      className="absolute right-3 top-3 z-[500] flex gap-0.5 rounded-xl border border-border bg-card/95 p-1 shadow-sm backdrop-blur">
      {OPCIONES.map((o) => (
        <button key={o.key} type="button" role="radio" aria-checked={value === o.key} onClick={() => onChange(o.key)}
          className={`h-8 whitespace-nowrap rounded-lg px-2 text-[12px] font-medium transition-colors sm:px-2.5 ${
            value === o.key ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
